import { Route, Routes } from 'react-router-dom'
import { ActivitiesBookingsPage } from './activitiesBookingsPage'
import { ActivityBookingItemPage } from './activityBookingItemPage'
import { ActivityMainForm } from './activityMainForm'
import { FormAddressPage } from '../subPages/formAddressPage'

export const ActivityRoutes = () => {
    return (
        <Routes>
            <Route
                key={'editActItemBase'}
                index
                element={<ActivityMainForm />}
            />
            <Route
                key={'activityAddress'}
                path="address"
                element={<FormAddressPage defaultToItin fieldName="address" />}
            />
            <Route
                path="bookings"
                key={'editActBookingsList'}
                element={<ActivitiesBookingsPage />}
            ></Route>
            <Route
                path="bookings/:idBooking"
                key={'editActBookingItem'}
                element={<ActivityBookingItemPage />}
            ></Route>
        </Routes>
    )
}
